import React, { useEffect, useRef, useState, useCallback } from "react";
import { GoogleOAuthProvider, GoogleLogin, googleLogout } from "@react-oauth/google";
import "./App.css";

const GOOGLE_CLIENT_ID = "816441155203-5pjdcgfp3rco1nathdq5lgge5l5q540r.apps.googleusercontent.com";

// ─── PLATFORMS CONFIGURATION ───
const PLATFORMS = [
  {
    id: "ambient",
    category: "engineering",
    badge: "Agentic Engineering",
    title: "Ambient Brain",
    subtitle: "Codebase & Architecture Voice RAG",
    desc: "Instant voice-driven document analysis and architectural unblocking. Ingest system design documents, specs, or codebase files to query complex engineering logic with zero acoustic latency.",
    metrics: "Sub-300ms TTFB • In-Memory RAG • Full-Duplex PCM",
    actionText: "Launch Ambient Brain →",
    theme: "#2dd4bf",
    themeRgb: "45, 212, 191",
    bgImage: "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?q=80&w=2564&auto=format&fit=crop"
  },
  {
    id: "safe_space",
    category: "crisis",
    badge: "Healthcare & Triage",
    title: "Safe Space",
    subtitle: "Confidential Student Mental Health Triage",
    desc: "24/7 zero-stigma voice support for academic and placement anxiety. Features automated background LLM severity analysis and real-time threat-level alerts for university counseling cells.",
    metrics: "Automated Threat Triage • Encrypted Context • Hinglish Native",
    actionText: "Enter Safe Space →",
    theme: "#10b981",
    themeRgb: "16, 185, 129",
    bgImage: "https://images.unsplash.com/photo-1550684848-fac1c5b4e853?q=80&w=2564&auto=format&fit=crop"
  },
  {
    id: "entertainment",
    category: "consumer",
    badge: "Dynamic Persona",
    title: "Forge Oracle & Mentors",
    subtitle: "Real-Time Acoustic Persona Engine",
    desc: "Zero-shot persona synthesis engine. Enter freeform character prompts to dynamically map acoustic neural models and custom system prompts for specialized sparring and mentorship.",
    metrics: "Zero-Shot Voice Mapping • Dynamic Synthesis • 12+ Presets",
    actionText: "Explore Oracles →",
    theme: "#00e5ff",
    themeRgb: "0, 229, 255",
    bgImage: "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=2564&auto=format&fit=crop"
  }
];

const MODE_CONFIGS = {
  entertainment: {
    title: "CROSSORACLE",
    tabs: ["All", "Mentors & Companions", "Wealth & Strategy", "Wellness & Care", "Mysticism & Wisdom"],
    theme: "#00e5ff",
  },
  safe_space: {
    title: "SAFE SPACE",
    tabs: ["All", "Academic Support", "Career Support", "Personal Support", "Anonymous Venting"],
    theme: "#10b981",
  },
  ambient: {
    title: "AMBIENT BRAIN",
    tabs: ["All", "Engineering", "Agentic Brain"],
    theme: "#2dd4bf",
  }
};

const PERSONAS = {
  // ── ENTERTAINMENT ──
  doctor:        { mode: "entertainment", id: "doctor",        category: "Wellness & Care",      name: "Dr. Aryan",        role: "Senior Physician",        image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?auto=format&fit=crop&w=400",                themeColor: "#00e5ff", rgb: "0, 229, 255",    tagline: "Aapki sehat, meri zimmedaari. Baat karte hain!",                            buttonText: "CONSULT NOW",       environment: "clinical"    },
  therapist:     { mode: "entertainment", id: "therapist",     category: "Wellness & Care",      name: "Dr. Tara",         role: "Clinical Psychologist",   image: "https://images.unsplash.com/photo-1551847677-dc82d7624c1c?auto=format&fit=crop&w=400",                themeColor: "#10b981", rgb: "16, 185, 129",  tagline: "Take a deep breath. Here, you are safe, heard, and understood.",              buttonText: "START THERAPY",     environment: "clinical"    },
  girlfriend:    { mode: "entertainment", id: "girlfriend",    category: "Wellness & Care",      name: "Aanya",            role: "Your Sweetheart",         image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=400",                themeColor: "#f87171", rgb: "248, 113, 113",  tagline: "Hey baby! Miss kiya tumhe, baat karte hain? 💕",                              buttonText: "CHAT WITH ME",      environment: "romantic"    },
  lawyer:        { mode: "entertainment", id: "lawyer",        category: "Wealth & Strategy",    name: "Adv. Nyay",        role: "Senior Advocate",         image: "https://images.unsplash.com/photo-1505664194779-8beaceb93744?auto=format&fit=crop&w=400",                themeColor: "#facc15", rgb: "250, 204, 21",   tagline: "Kanoon ke saath, justice ki baat. Samajhte hain!",                            buttonText: "GET ADVICE",        environment: "courtroom"   },
  entrepreneur:  { mode: "entertainment", id: "entrepreneur",  category: "Wealth & Strategy",    name: "Ravi Kapoor",      role: "Startup Mentor",          image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop",          themeColor: "#a78bfa", rgb: "167, 139, 250",  tagline: "Boss, startup shuru karna hai? Let's hustle!",                                buttonText: "TALK BUSINESS",     environment: "startup"     },
  wealth_manager:{ mode: "entertainment", id: "wealth_manager",category: "Wealth & Strategy",    name: "Kuber Singh",      role: "Wealth Architect",        image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=400",                themeColor: "#14b8a6", rgb: "20, 184, 166",   tagline: "Markets don't sleep, neither does money. Let's build your portfolio.",        buttonText: "TALK MONEY",        environment: "startup"     },
  strategist:    { mode: "entertainment", id: "strategist",    category: "Wealth & Strategy",    name: "Arya Chanakya",    role: "Master Strategist",       image: "https://images.unsplash.com/photo-1604580864964-0462f5d5b1a8?auto=format&fit=crop&w=400",                themeColor: "#b91c1c", rgb: "185, 28, 28",    tagline: "नीति और रणनीति। भावनाओं को किनारे रखो, परिणाम पर ध्यान दो।",                buttonText: "SEEK STRATEGY",     environment: "courtroom"   },
  astrologer:    { mode: "entertainment", id: "astrologer",    category: "Mysticism & Wisdom",   name: "Acharya Ved",      role: "Jyotish Acharya",         image: "https://images.unsplash.com/photo-1532968961962-8a0cb3a2d4f5?auto=format&fit=crop&w=400",                themeColor: "#fb923c", rgb: "251, 146, 60",   tagline: "राधे राधे! आओ बेटा, सितारों की बात करते हैं!",                               buttonText: "TALK TO PANDIT JI", environment: "cosmic"      },
  monk:          { mode: "entertainment", id: "monk",          category: "Mysticism & Wisdom",   name: "Swami Kabir",      role: "Spiritual Mystic",        image: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?auto=format&fit=crop&w=400",                themeColor: "#f59e0b", rgb: "245, 158, 11",   tagline: "मोह छोड़ो। जो है, बस यही पल है। सत्य की खोज करें।",                        buttonText: "SEEK WISDOM",       environment: "cosmic"      },
  teacher:       { mode: "entertainment", id: "teacher",       category: "Mentors & Companions", name: "Prof. Data",       role: "Professor",               image: "https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=400",                themeColor: "#22d3ee", rgb: "34, 211, 238",   tagline: "Concept clear karein. Fast. Sharp. Brilliant.",                               buttonText: "START LEARNING",    environment: "academic"    },
  career_coach:  { mode: "entertainment", id: "career_coach",  category: "Mentors & Companions", name: "Priya Sharma",     role: "Career Counselor",        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=400",                themeColor: "#f472b6", rgb: "244, 114, 182",  tagline: "Tumhara career path clear karein. Together!",                                 buttonText: "GET GUIDANCE",      environment: "professional"},
  debater:       { mode: "entertainment", id: "debater",       category: "Mentors & Companions", name: "Devil's Advocate", role: "Intellectual Sparring",   image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=400",                themeColor: "#ef4444", rgb: "239, 68, 68",    tagline: "Prove it. I will challenge everything you think you know.",                  buttonText: "START DEBATE",      environment: "courtroom"   },
  drill_sergeant:{ mode: "entertainment", id: "drill_sergeant",category: "Mentors & Companions", name: "Coach Vikram",     role: "Performance Coach",       image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=400",                themeColor: "#d946ef", rgb: "217, 70, 239",   tagline: "No excuses. No sympathy. Get up and put in the work.",                       buttonText: "GET DISCIPLINED",   environment: "startup"     },

  // ── SAFE SPACE ──
  academic_coach: {
    mode: "safe_space", id: "academic_coach", category: "Academic Support", name: "Dr. Neeti", role: "Academic Stress Coach",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=400",
    themeColor: "#3b82f6", rgb: "59, 130, 246",
    tagline: "CGPA anxiety or course overload? Let's untangle it together.", buttonText: "START SESSION", environment: "clinical",
  },
  placement_counsellor: {
    mode: "safe_space", id: "placement_counsellor", category: "Career Support", name: "Meera", role: "Placement Anxiety Counsellor",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=400",
    themeColor: "#10b981", rgb: "16, 185, 129",
    tagline: "Interviews are scary. Rejections hurt. I'm here to help you navigate placement season.", buttonText: "TALK TO MEERA", environment: "clinical",
  },
  relationship_advisor: {
    mode: "safe_space", id: "relationship_advisor", category: "Personal Support", name: "Sanya", role: "Relationship & Peer Advisor",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=400",
    themeColor: "#f43f5e", rgb: "244, 63, 94",
    tagline: "Hostel politics, family pressure, or just feeling lonely? Let's talk.", buttonText: "CONNECT", environment: "warm",
  },
  venting_partner: {
    mode: "safe_space", id: "venting_partner", category: "Anonymous Venting", name: "The Listener", role: "Anonymous Venting Partner",
    image: "https://images.unsplash.com/photo-1516585427167-9f4af9627e6c?auto=format&fit=crop&w=400",
    themeColor: "#8b5cf6", rgb: "139, 92, 246",
    tagline: "No advice. No judgment. Just a safe space to let it all out. I'm listening.", buttonText: "START VENTING", environment: "dark",
  },

  // ── AMBIENT BRAIN ──
  serious_kt: {
    mode: "ambient", id: "serious_kt", category: "Engineering", name: "Archie (Pro)", role: "Senior Architect",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c31e6?auto=format&fit=crop&w=400",
    themeColor: "#3b82f6", rgb: "59, 130, 246",
    tagline: "Serious, technical, and ready for deployment.", buttonText: "PROFESSIONAL MODE", environment: "clinical",
  },
  funny_kt: {
    mode: "ambient", id: "funny_kt", category: "Engineering", name: "Dev Chaos", role: "The Weekend Coder",
    image: "https://images.unsplash.com/photo-1596495578065-6e0763fa1178?auto=format&fit=crop&w=400",
    themeColor: "#f59e0b", rgb: "245, 158, 11",
    tagline: "I built this at 3 AM. Don't touch the Redis config.", buttonText: "CHAOS MODE", environment: "warm",
  },
  agentic_brain: { 
    mode: "ambient", id: "agentic_brain", category: "Agentic Brain", name: "Doc-Oracle Brain", role: "Document Analyst",        
    image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&w=400",                
    themeColor: "#a78bfa", rgb: "167, 139, 250",  
    tagline: "Upload a document to inject context and analyze it using voice AI.", buttonText: "ANALYZE DOC", environment: "academic"    
  },
};

// ── PERSONA TEMPLATES FOR CUSTOM ORACLE ──
const PERSONA_TEMPLATES = [
  { label: "Firebrand Politician", emoji: "🎭", text: "A passionate and commanding Indian politician who delivers fiery speeches, quotes the Constitution, uses powerful nationalist slogans, rallies crowds with dramatic Hindi rhetoric, and turns every single conversation into a bold political manifesto about the nation's destiny and future." },
  { label: "Bollywood Filmmaker",  emoji: "🎬", text: "A dramatic and passionate Bollywood director who sees all of life through the cinematic lens, references iconic film dialogues in every conversation, treats every discussion like a pivotal scene in a masterpiece, speaks in vivid metaphors, and is obsessed with emotion, drama, and the perfect shot." },
  { label: "Street Philosopher",   emoji: "🕯️", text: "A wandering philosopher from the ancient ghats of Varanasi who speaks in paradoxes and riddles, quotes Kabir, Rumi, and Osho with great ease, finds deep cosmic meaning in the simplest everyday moments, and gently dismantles every assumption and belief that the listener holds about life." },
  { label: "Corporate Shark",      emoji: "💼", text: "A ruthless and highly ambitious corporate executive who thinks exclusively in KPIs, quarterly targets, and ROI, speaks in crisp business jargon, has absolutely zero tolerance for inefficiency or wasted time, and turns every conversation into either a negotiation or a high-stakes boardroom power play." },
  { label: "Cricket Legend",       emoji: "🏏", text: "A legendary retired Indian cricketer and national hero who uses cricket as a powerful metaphor for every life situation, shares priceless locker room wisdom from decades of experience, speaks with calm unshakeable authority, and deeply believes that true character is built only under pressure on the pitch." },
  { label: "Desi Scientist",       emoji: "🔬", text: "An enthusiastic and highly passionate ISRO scientist who explains absolutely everything through the lens of physics and space exploration, gets genuinely excited about numbers and scientific discoveries, uses clever analogies from everyday Indian life to explain complex science, and firmly believes India's greatest scientific achievements are still ahead." },
];

const CLIENT_VOICE_BUCKETS = [
  { label: "Authority Female",      color: "#f472b6", emoji: "👩‍💼", keywords: ["female leader","boss lady","straightforward female","female boss","matriarch","manager","female politician","strong woman","strict lady","authoritative female","director"] },
  { label: "Cartoonish Female",     color: "#ff66b2", emoji: "🌸",  keywords: ["cartoonish","anime","childlike","cute","high-pitched","squeaky","cartoon","pixar","disney","manga","kawaii","chibi","anime girl","cartoon girl","little girl"] },
  { label: "Energetic Female",      color: "#ec4899", emoji: "⚡",  keywords: ["ecommerce","shopping","energetic girl","bubbly","salesgirl","influencer","youtuber","hype girl","young female","excited girl","fashion","makeup","girl"] },
  { label: "Empathetic Female",     color: "#fb7185", emoji: "💖",  keywords: ["sensual","empathetic","intimate female","deep talk","comforting","romantic female","girlfriend","lover","therapist","caring girl","gentle female","soft spoken female","wife"] },
  { label: "Romantic Male",         color: "#8b0000", emoji: "🌹",  keywords: ["romantic male","intimate male","boyfriend","lover","charming","flirty","handsome","deep intimate","romantic","husband","date"] },
  { label: "Authority Male",        color: "#facc15", emoji: "👑",  keywords: ["politician","political","minister","leader","neta","president","commander","military","general","authority","judge","governor","revolutionary","rebel","villain","gangster","don","boss","baahubali","king","emperor","dictator","chancellor","prime minister"] },
  { label: "Mystical Voice",        color: "#a78bfa", emoji: "🌌",  keywords: ["mystic","philosopher","ancient","sage","guru","monk","yogi","saint","prophet","oracle","wizard","shaman","stoic","chanakya","aristotle","buddha","sufi","vedic","spiritual","cosmic","enlightened"] },
  { label: "Expressive Voice",      color: "#fb923c", emoji: "🎭",  keywords: ["storyteller","narrator","anchor","journalist","host","comedian","actor","playwright","bard","poet","historian","documentary","podcast","radio","news","filmmaker","director","bollywood","cricket","sports commentator"] },
  { label: "Warm Male",             color: "#10b981", emoji: "🤝",  keywords: ["friend","buddy","companion","mentor","parent","father","dost","yaar","bhai","counselor","advisor","guide","uncle","elder","senior","humble","gentle","caring male","kind","warm male","tea vala","chaiwala"] },
  { label: "Professional / Upbeat", color: "#22d3ee", emoji: "💼",  keywords: ["fitness","gym","trainer","coach","motivator","athlete","sports","energy","hype","salesman","marketer","entrepreneur","hustler","startup","professional"] },
  { label: "General Female",        color: "#f9a8d4", emoji: "✨",  keywords: ["woman","female","lady","sister","mother","nurse","aunty","didi","behen","queen","actress","hostess"] },
];

function detectVoiceClient(description) {
  const lower = description.toLowerCase();
  for (const bucket of CLIENT_VOICE_BUCKETS) {
    if (bucket.keywords.some(k => lower.includes(k))) return bucket;
  }
  return { label: "Professional Voice", color: "#00e5ff", emoji: "🎤" };
}

const getApiBaseUrl = () => {
  const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  return isLocal ? "http://127.0.0.1:3001" : "https://theoutercircle-f2cfdudcdrfvc8cd.swedencentral-01.azurewebsites.net";
};

const getSocketUrl = () => {
  const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  return isLocal ? "ws://127.0.0.1:3001" : "wss://theoutercircle-f2cfdudcdrfvc8cd.swedencentral-01.azurewebsites.net";
};

const MISHEAR_TOAST_DURATION = 2500;
const MAX_DESC_LENGTH        = 400;

export default function App() {
  const wsRef                = useRef(null);
  const audioCtxRef          = useRef(null);
  const streamRef            = useRef(null);
  const audioQueueRef        = useRef([]);
  const isPlayingRef         = useRef(false);
  const currentSourceRef     = useRef(null);
  const generationIdRef      = useRef(0);
  const heartbeatIntervalRef = useRef(null);
  const processorRef         = useRef(null);
  const sourceNodeRef        = useRef(null);
  const analyzerRef          = useRef(null);
  const animationFrameRef    = useRef(null);
  const mishearTimerRef      = useRef(null);

  // ── APP & NAVIGATION STATE ──
  const [appMode, setAppMode] = useState(() => localStorage.getItem("crossoracle_mode") || null);
  const [landingTab, setLandingTab] = useState("all");

  const [persona,           setPersona]          = useState(null);
  const [recording,         setRecording]        = useState(false);
  const [aiIsSpeaking,      setAiIsSpeaking]     = useState(false);
  const [isAiThinking,      setIsAiThinking]     = useState(false);
  const [isConnected,       setIsConnected]      = useState(false);
  const [isUserTalking,     setIsUserTalking]    = useState(false);
  const [inCall,            setInCall]           = useState(false);
  const [mishearToast,      setMishearToast]     = useState(false);
  const [nameError,         setNameError]        = useState("");
  const [activeTab,         setActiveTab]        = useState("All");
  const [isDrawerOpen,      setIsDrawerOpen]     = useState(false);
  const [showTelemetryHUD,  setShowTelemetryHUD] = useState(false);
  const [telemetryLogs,     setTelemetryLogs]    = useState([]);
  const clickCountRef        = useRef(0);
  const clickTimerRef        = useRef(null);
  
  const [user,              setUser]             = useState(() => {
    const saved = localStorage.getItem("crossoracle_user");
    return saved ? JSON.parse(saved) : null;
  });
  const [customName,        setCustomName]       = useState(() => localStorage.getItem("crossoracle_name") || "");
  const [hindiName,         setHindiName]        = useState(() => localStorage.getItem("crossoracle_hindi") || "");
  
  const [showNameModal,     setShowNameModal]    = useState(false);
  const [authEmail,         setAuthEmail]        = useState("");
  const [authPassword,      setAuthPassword]     = useState("");
  const [authError,         setAuthError]        = useState("");
  
  const [showForgeModal,    setShowForgeModal]   = useState(false);
  const [forgeDesc,         setForgeDesc]        = useState("");
  const [forgeName,         setForgeName]        = useState("");
  const [forgeForming,      setForgeForming]     = useState(false);
  const [customPersonaInfo, setCustomPersonaInfo]= useState(null);
  const [callPersonaInfo,   setCallPersonaInfo]  = useState(null);
  
  const [showProfile,       setShowProfile]      = useState(false);
  const [allSessions,       setAllSessions]      = useState([]);
  const [sessionDuration,   setSessionDuration]  = useState(0);
  const callTimerRef = useRef(null);

  const [uploadStatus, setUploadStatus] = useState("");

  const logTelemetry = useCallback((metricName, value, unit) => {
    setTelemetryLogs(prev => {
      const newLogs = [...prev, { id: Date.now() + Math.random(), type: 'metric', name: metricName, value: `${value}${unit}` }];
      return newLogs.length > 50 ? newLogs.slice(newLogs.length - 50) : newLogs; 
    });
  }, []);

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const handleLogoClick = () => {
    clickCountRef.current += 1;
    if (clickTimerRef.current) clearTimeout(clickTimerRef.current);
    if (clickCountRef.current >= 3) {
      setShowTelemetryHUD(prev => !prev);
      clickCountRef.current = 0;
    } else {
      clickTimerRef.current = setTimeout(() => { clickCountRef.current = 0; }, 1000);
    }
  };

  useEffect(() => {
    if (appMode === "entertainment") setPersona("doctor");
    else if (appMode === "safe_space") setPersona("academic_coach");
    else if (appMode === "ambient") setPersona("serious_kt");
  }, [appMode]);

  useEffect(() => {
    if (user && customName && !showNameModal) connectWS();
    return () => {
      wsRef.current?.close();
      stopCall();
      if (heartbeatIntervalRef.current) clearInterval(heartbeatIntervalRef.current);
      if (mishearTimerRef.current)      clearTimeout(mishearTimerRef.current);
      if (audioCtxRef.current)          { audioCtxRef.current.close(); audioCtxRef.current = null; }
    };
  }, [user, customName, showNameModal]);

  useEffect(() => {
    const debounce = setTimeout(async () => {
      if (!customName.trim()) { setHindiName(""); return; }
      try {
        const res  = await fetch(`https://inputtools.google.com/request?text=${customName}&itc=hi-t-i0-und&num=1&cp=0&cs=1&ie=utf-8&oe=utf-8&app=demopage`);
        const data = await res.json();
        setHindiName(data[0] === "SUCCESS" && data[1][0][1][0] ? data[1][0][1][0] : "");
      } catch { setHindiName(""); }
    }, 400);
    return () => clearTimeout(debounce);
  }, [customName]);

  useEffect(() => {
    const handler = (e) => {
      if (e.code === "Space" && (aiIsSpeaking || isAiThinking) && inCall) { e.preventDefault(); interruptAI(); }
      if (e.code === "Escape") { setIsDrawerOpen(false); setShowForgeModal(false); }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [aiIsSpeaking, isAiThinking, inCall]);

  const handleModeSelect = (mode) => {
    setAppMode(mode);
    localStorage.setItem("crossoracle_mode", mode);
    setActiveTab("All");
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const res  = await fetch(`${getApiBaseUrl()}/auth/google`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token: credentialResponse.credential }) });
      const data = await res.json();
      if (data.success) { setUser(data.user); setCustomName(""); setHindiName(""); setShowNameModal(true); }
    } catch (err) { console.error("Login failed", err); }
  };

  const handleCustomLogin = async (e) => {
    e.preventDefault();
    setAuthError("");
    try {
      const res = await fetch(`${getApiBaseUrl()}/auth/login`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email: authEmail, password: authPassword }) });
      const data = await res.json();
      if (data.success) { setUser(data.user); setCustomName(""); setHindiName(""); setShowNameModal(true); } else { setAuthError(data.message || "Invalid credentials"); }
    } catch (err) { setAuthError("Failed to connect to server"); }
  };

  const handleNameSubmit = (e) => {
    e.preventDefault();
    const cleanName = customName.trim();
    if (cleanName.includes(" "))  { setNameError("Please enter a single first name (no spaces)."); setTimeout(() => setNameError(""), 3000); return; }
    if (cleanName.length >= 10)   { setNameError("Name must be less than 10 characters.");          setTimeout(() => setNameError(""), 3000); return; }
    if (cleanName.length > 0) {
      setShowNameModal(false);
      localStorage.setItem("crossoracle_user",  JSON.stringify(user));
      localStorage.setItem("crossoracle_name",  cleanName);
      localStorage.setItem("crossoracle_hindi", hindiName);
    }
  };

  const handleLogout = () => {
    googleLogout();
    setUser(null); setCustomName(""); setHindiName(""); setShowNameModal(false);
    setAuthEmail(""); setAuthPassword(""); 
    setAppMode(null);
    localStorage.removeItem("crossoracle_user"); localStorage.removeItem("crossoracle_name"); localStorage.removeItem("crossoracle_hindi"); localStorage.removeItem("crossoracle_mode");
    if (wsRef.current) { wsRef.current.close(); wsRef.current = null; }
    setIsConnected(false);
    stopCall();
  };

  const fetchAllSessions = async () => {
    if (!user?.email || user.role !== "counsellor") return;
    try {
      const res = await fetch(`${getApiBaseUrl()}/api/admin/sessions?email=${user.email}`);
      const data = await res.json();
      if (data.success) setAllSessions(data.sessions);
    } catch (err) {}
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    const isPdf = file.type === "application/pdf" || fileName.endsWith(".pdf");
    const isTextLike = [".txt", ".md", ".json", ".csv"].some(ext => fileName.endsWith(ext));
    setUploadStatus(isPdf ? "Reading PDF..." : isTextLike ? "Extracting text..." : "Processing document...");

    try {
      const payload = {
        email: user?.email,
        docName: file.name,
        mimeType: file.type || "application/octet-stream",
        fileType: fileName.split(".").pop() || "unknown",
      };

      if (isPdf) {
        const buffer = await file.arrayBuffer();
        const bytes = new Uint8Array(buffer);
        let binary = "";
        const chunkSize = 0x8000;
        for (let i = 0; i < bytes.length; i += chunkSize) {
          binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
        }
        payload.docBase64 = btoa(binary);
      } else {
        payload.docText = await file.text();
      }

      const res = await fetch(`${getApiBaseUrl()}/api/upload-context`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        setUploadStatus(`Document "${file.name}" loaded successfully.`);
      } else {
        const response = await res.json().catch(() => ({}));
        setUploadStatus(response?.message || "Failed to upload document context.");
      }
    } catch (err) {
      setUploadStatus("Network error during upload.");
    }
  };

  const showMishearToast = () => {
    setMishearToast(true);
    if (mishearTimerRef.current) clearTimeout(mishearTimerRef.current);
    mishearTimerRef.current = setTimeout(() => setMishearToast(false), MISHEAR_TOAST_DURATION);
  };

  const connectWS = () => {
    if (wsRef.current?.readyState === WebSocket.OPEN) return;
    const ws      = new WebSocket(getSocketUrl());
    ws.binaryType = "arraybuffer";
    ws.onopen = () => { setIsConnected(true); heartbeatIntervalRef.current = setInterval(() => { if (ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify({ type: "ping" })); }, 30000); };
    ws.onmessage = async (e) => {
      if (e.data instanceof ArrayBuffer) {
        audioQueueRef.current.push({ data: e.data, genId: generationIdRef.current }); playNextAudio();
      } else {
        const m = JSON.parse(e.data);
        if (m.type === "telemetry") { logTelemetry(m.metric, m.value, m.unit); }
        if (m.type === "transcript") { setTelemetryLogs(prev => { const newLogs = [...prev, { id: Date.now() + Math.random(), type: 'user', text: `You: ${m.text}` }]; return newLogs.length > 50 ? newLogs.slice(newLogs.length - 50) : newLogs; }); setIsAiThinking(true); setMishearToast(false); if (mishearTimerRef.current) clearTimeout(mishearTimerRef.current); }
        if (m.type === "persona_set") { setIsAiThinking(false); setAiIsSpeaking(false); setForgeForming(false); if (m.isCustom) setCustomPersonaInfo({ id: m.persona, name: m.personaName }); }
        if (m.type === "stt_mishear") { setTelemetryLogs(prev => { const newLogs = [...prev, { id: Date.now() + Math.random(), type: 'warn', text: `Filtered Mishear: ${m.raw}` }]; return newLogs.length > 50 ? newLogs.slice(newLogs.length - 50) : newLogs; }); showMishearToast(); }
      }
    };
    ws.onerror  = (err) => console.error("❌ WS Error:", err);
    ws.onclose  = () => { setIsConnected(false); setTimeout(connectWS, 3000); };
    wsRef.current = ws;
  };

  const interruptAI = () => {
    generationIdRef.current += 1; audioQueueRef.current = [];
    if (currentSourceRef.current) { try { currentSourceRef.current.stop(); currentSourceRef.current.disconnect(); } catch {} currentSourceRef.current = null; }
    isPlayingRef.current = false; setAiIsSpeaking(false); setIsAiThinking(false);
    if (wsRef.current?.readyState === 1) wsRef.current.send(JSON.stringify({ type: "interrupt" }));
  };

  const playNextAudio = async () => {
    if (isPlayingRef.current || !audioQueueRef.current.length) { if (!audioQueueRef.current.length) setAiIsSpeaking(false); return; }
    const item = audioQueueRef.current.shift();
    if (item.genId !== generationIdRef.current) return playNextAudio();
    isPlayingRef.current = true; setIsAiThinking(false); setAiIsSpeaking(true);
    try {
      if (!audioCtxRef.current) { isPlayingRef.current = false; return; }
      if (audioCtxRef.current.state === "suspended") await audioCtxRef.current.resume();
      const pcmData = new Int16Array(item.data); const buf = audioCtxRef.current.createBuffer(1, pcmData.length, 16000); const ch = buf.getChannelData(0); for (let i = 0; i < pcmData.length; i++) ch[i] = pcmData[i] / 32768.0;
      const src = audioCtxRef.current.createBufferSource(); src.buffer = buf; src.connect(audioCtxRef.current.destination); currentSourceRef.current = src;
      src.onended = () => { isPlayingRef.current = false; currentSourceRef.current = null; playNextAudio(); }; src.start(0);
    } catch (e) { isPlayingRef.current = false; playNextAudio(); }
  };

  const startCall = async () => {
    if (!audioCtxRef.current) { alert("Please try again."); return; }
    if (audioCtxRef.current.state === "suspended") await audioCtxRef.current.resume();
    const stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true, channelCount: 1 } });
    streamRef.current = stream;
    const source = audioCtxRef.current.createMediaStreamSource(stream); sourceNodeRef.current = source;
    const analyzer = audioCtxRef.current.createAnalyser(); analyzer.fftSize = 256; analyzer.smoothingTimeConstant = 0.8; analyzerRef.current = analyzer; source.connect(analyzer);
    const dataArr = new Uint8Array(analyzer.frequencyBinCount);
    const checkVol = () => { if (!streamRef.current || !analyzerRef.current) return; analyzerRef.current.getByteFrequencyData(dataArr); setIsUserTalking(dataArr.reduce((a, b) => a + b) / dataArr.length > 35); animationFrameRef.current = requestAnimationFrame(checkVol); }; checkVol();
    const processor = audioCtxRef.current.createScriptProcessor(4096, 1, 1); processorRef.current = processor; source.connect(processor); processor.connect(audioCtxRef.current.destination);
    const ratio = audioCtxRef.current.sampleRate / 16000;
    processor.onaudioprocess = (e) => {
      if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) return;
      const input = e.inputBuffer.getChannelData(0); const pcm16 = new Int16Array(Math.floor(input.length / ratio));
      for (let i = 0; i < pcm16.length; i++) { pcm16[i] = Math.max(-1, Math.min(1, input[Math.floor(i * ratio)])) * 0x7fff; }
      wsRef.current.send(pcm16.buffer);
    };
    setRecording(true); setInCall(true); setSessionDuration(0);
    if (callTimerRef.current) clearInterval(callTimerRef.current);
    callTimerRef.current = setInterval(() => { setSessionDuration(prev => prev + 1); }, 1000);
  };

  const stopCall = () => {
    if (animationFrameRef.current) { cancelAnimationFrame(animationFrameRef.current); animationFrameRef.current = null; }
    if (processorRef.current)      { try { processorRef.current.disconnect(); processorRef.current.onaudioprocess = null; } catch {} processorRef.current = null; }
    if (sourceNodeRef.current)     { try { sourceNodeRef.current.disconnect(); } catch {} sourceNodeRef.current = null; }
    analyzerRef.current = null;
    if (streamRef.current)         { streamRef.current.getTracks().forEach(t => t.stop()); streamRef.current = null; }
    setRecording(false); setIsUserTalking(false); setInCall(false); setMishearToast(false);
    if (callTimerRef.current) { clearInterval(callTimerRef.current); callTimerRef.current = null; }
    interruptAI();
    setTimeout(() => { 
      if (user?.role === 'counsellor' && appMode === 'safe_space') fetchAllSessions();
    }, 1500);
  };

  const toggleCall = async (id) => {
    if (!audioCtxRef.current) { try { audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)(); } catch { alert("Audio init failed."); return; } }
    if (audioCtxRef.current.state === "suspended") { try { await audioCtxRef.current.resume(); } catch {} }
    if (recording && persona === id) { stopCall(); return; }
    if (recording) stopCall();
    setPersona(id);
    if (wsRef.current?.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify({ type: "set_persona", persona: id, userName: hindiName || customName, userEmail: user?.email || null }));
      setTimeout(() => startCall(), 50);
    } else { alert("Reconnecting… please try again."); }
  };

  const launchCustomPersonaCall = async () => {
    const desc = forgeDesc.trim(); if (desc.length < 15) return;
    if (!audioCtxRef.current) { try { audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)(); } catch { alert("Audio init failed."); return; } }
    if (audioCtxRef.current.state === "suspended") { try { await audioCtxRef.current.resume(); } catch {} }
    if (recording) stopCall();
    setForgeForming(true); setShowForgeModal(false); setForgeName("");
    if (wsRef.current?.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify({ type: "set_custom_persona", description: desc, personaName: forgeName.trim() || null, userName: hindiName || customName, userEmail: user?.email || null }));
      const voice = detectVoiceClient(desc);
      setCallPersonaInfo({ name: forgeName.trim() || "Custom Oracle", role: "Your Creation", image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&w=400", themeColor: voice.color, rgb: "100, 100, 200", environment: "cosmic" });
      setPersona("__custom__");
      setTimeout(() => startCall(), 50);
    } else { alert("Reconnecting… please try again."); setForgeForming(false); }
  };

  const TelemetryTerminal = ({ logs, onClose }) => {
    const endOfLogsRef = useRef(null);
    const [paused, setPaused] = useState(false);
    const displayedLogs = paused ? logs.filter((_, i) => i < 10) : logs;
    const getLatest = (metricName) => { const found = [...logs].reverse().find(l => l.name === metricName); return found ? found.value : "---"; };
    useEffect(() => { if (!paused) endOfLogsRef.current?.scrollIntoView({ behavior: "smooth" }); }, [logs, paused]);
    return (
      <div style={{ position: 'fixed', top: '100px', right: '20px', width: '350px', height: '500px', background: 'rgba(8, 12, 26, 0.95)', border: '1px solid rgba(0, 229, 255, 0.5)', borderRadius: '16px', backdropFilter: 'blur(20px)', zIndex: 99999, display: 'flex', flexDirection: 'column', boxShadow: '0 20px 50px rgba(0,0,0,0.8)', overflow: 'hidden' }}>
        <div style={{ padding: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(0, 229, 255, 0.2)' }}>
          <span style={{ color: '#00e5ff', fontSize: '10px', letterSpacing: '2px', fontWeight: 'bold' }}>SYSTEM ANALYTICS</span>
          <div style={{ display: 'flex', gap: '10px' }}><button onClick={() => setPaused(!paused)} style={{ background: paused ? '#10b981' : '#334155', color: 'white', border: 'none', borderRadius: '4px', padding: '2px 8px', fontSize: '10px', cursor: 'pointer' }}>{paused ? "RESUME" : "PAUSE"}</button><button onClick={onClose} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}>✕</button></div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px', background: '#1e293b', borderBottom: '1px solid #1e293b' }}>
          {[{ label: "LLM TTFB", key: "LLM TTFB" }, { label: "TTS RTF", key: "ElevenLabs RTF" }, { label: "Barge-in", key: "Barge-in Latency" }, { label: "Chunk Latency", key: "TTS Latency" }].map(stat => (
            <div key={stat.label} style={{ background: 'rgba(15, 23, 42, 0.9)', padding: '10px', textAlign: 'center' }}><div style={{ color: '#64748b', fontSize: '9px', marginBottom: '4px' }}>{stat.label}</div><div style={{ color: '#00e5ff', fontSize: '16px', fontWeight: 'bold' }}>{getLatest(stat.key)}</div></div>
          ))}
        </div>
        <div style={{ padding: '10px', overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: '4px', background: 'rgba(0,0,0,0.2)' }}>
          {displayedLogs.map((log) => (<div key={log.id} style={{ fontSize: '10px', lineHeight: '1.2', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '2px' }}>{log.type === 'metric' && <><span style={{ color: '#00e5ff' }}>[{log.name}]</span> <span style={{ color: '#fff' }}>{log.value}</span></>}{log.type === 'user' && <span style={{ color: '#10b981' }}>{log.text}</span>}{log.type === 'warn' && <span style={{ color: '#f59e0b' }}>{log.text}</span>}</div>))}
          <div ref={endOfLogsRef} />
        </div>
      </div>
    );
  };

  const currentConfig = MODE_CONFIGS[appMode] || MODE_CONFIGS.entertainment;
  const currentPersona = callPersonaInfo || PERSONAS[persona] || Object.values(PERSONAS).find(p => p.mode === appMode);
  const filteredPersonas = Object.values(PERSONAS).filter(
    p => p.mode === appMode && (activeTab === "All" || p.category === activeTab)
  );

  const filteredLandingTools = landingTab === "all" ? PLATFORMS : PLATFORMS.filter(p => p.category === landingTab);

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <div className={`app-shell ${inCall ? "in-call" : ""}`} style={{ "--active-color": currentPersona?.themeColor || "#00e5ff", "--active-color-rgb": currentPersona?.rgb || "0,229,255" }} data-environment={inCall ? currentPersona?.environment : "none"}>
        
        {/* RESEARCH PAPER BADGE PINNED AT BOTTOM CORNER */}
        {!inCall && (
          <a href="https://aclanthology.org/2026.sigdial-1.18/" target="_blank" rel="noopener noreferrer" className="research-paper-badge">
            <div className="research-paper-icon">📄</div>
            <span className="research-paper-text">SIGDIAL 2026 Paper</span>
          </a>
        )}

        <div className="outer-orbit-bg"></div>
        <div className="environment-layer"></div>

        {/* ── 1. UNIFIED ENTERPRISE LANDING PAGE ── */}
        {!appMode && !user && (
          <div className="landing-root">
            {/* NAVIGATION */}
            <nav className="landing-nav">
              <div className="nav-container">
                <div className="brand-badge">
                  <span className="brand-dot"></span>
                  CROSS<strong>ORACLE</strong>
                </div>
                <div className="nav-links">
                  <a href="#services">Platforms</a>
                  <a href="#architecture">Latency Engine</a>
                  <a href="#founder">About Founder</a>
                  <a href="https://aclanthology.org/2026.sigdial-1.18/" target="_blank" rel="noreferrer" className="paper-nav-link">
                    SIGDIAL 2026 Paper ↗
                  </a>
                </div>
                <button className="nav-cta-btn" onClick={() => handleModeSelect("entertainment")}>
                  Launch App
                </button>
              </div>
            </nav>

            {/* HERO SECTION */}
            <section className="hero-section">
              <div className="hero-badge">
                <span className="pulse-indicator"></span> AI VOICE PERSONAS — BUILT FOR INDIA
              </div>
              <h1 className="hero-heading">
                Talk to AI Characters <br />
                <span>That Actually Get You</span>
              </h1>
              <p className="hero-subtext">
                Not just one assistant — pick from 12+ unique AI personas, create your own, and talk in Hindi, English, or Hinglish. Interrupt anytime, get instant replies, and use purpose-built modes for mentorship, wellness, and engineering.
              </p>

              <div className="hero-cta-group">
                <button className="primary-hero-btn" onClick={() => handleModeSelect("ambient")}>
                  Explore Agentic Brain
                </button>
                <button className="secondary-hero-btn" onClick={() => handleModeSelect("safe_space")}>
                  Safe Space Triage
                </button>
              </div>

              {/* METRICS BANNER */}
              <div className="metrics-banner">
                <div className="metric-item">
                  <h3>12+ Personas</h3>
                  <p>Doctors, Mentors, Mystics & More</p>
                </div>
                <div className="metric-divider"></div>
                <div className="metric-item">
                  <h3>Hinglish Native</h3>
                  <p>Hindi, English & Mixed</p>
                </div>
                <div className="metric-divider"></div>
                <div className="metric-item">
                  <h3>Instant Replies</h3>
                  <p>Interrupt & Talk Naturally</p>
                </div>
                <div className="metric-divider"></div>
                <div className="metric-item">
                  <h3>Create Your Own</h3>
                  <p>Forge Custom AI Characters</p>
                </div>
              </div>
            </section>

            {/* SERVICES & TOOLS DEEP-DIVE */}
            <section className="services-section" id="services">
              <div className="section-header">
                <span className="section-tag">SERVICES & TOOLS</span>
                <h2>Specialized Voice AI Workspaces</h2>
                <p>Purpose-built voice execution environments optimized for mission-critical workflows.</p>
                
                <div className="category-filter-tabs">
                  <button className={landingTab === "all" ? "active" : ""} onClick={() => setLandingTab("all")}>All Platforms</button>
                  <button className={landingTab === "engineering" ? "active" : ""} onClick={() => setLandingTab("engineering")}>Engineering</button>
                  <button className={landingTab === "crisis" ? "active" : ""} onClick={() => setLandingTab("crisis")}>Institutional Triage</button>
                  <button className={landingTab === "consumer" ? "active" : ""} onClick={() => setLandingTab("consumer")}>Persona Synthesis</button>
                </div>
              </div>

              <div className="tools-grid">
                {filteredLandingTools.map((tool) => (
                  <div 
                    key={tool.id} 
                    className="tool-card" 
                    style={{ "--card-accent": tool.theme }}
                    onClick={() => handleModeSelect(tool.id)}
                  >
                    <div className="tool-card-content-wrapper">
                      <div className="tool-card-top">
                        <span className="tool-badge">{tool.badge}</span>
                        <span className="arrow-icon">↗</span>
                      </div>
                      <h3 className="tool-title">{tool.title}</h3>
                      <h4 className="tool-subtitle">{tool.subtitle}</h4>
                      <p className="tool-desc">{tool.desc}</p>
                    </div>
                    <div className="tool-card-footer">
                      <div className="tool-metrics">{tool.metrics}</div>
                      <span className="tool-action-link">{tool.actionText}</span>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* ARCHITECTURAL ENGINE & LATENCY EXPLAINER */}
            <section className="architecture-section" id="architecture">
              <div className="section-header">
                <span className="section-tag">ENGINEERING MOAT</span>
                <h2>How Crossoracle Solves the Voice Latency Bottleneck</h2>
                <p>Generic voice APIs rely on slow, sequential request-response turns. Crossoracle is architected from the bare metal for conversational flow.</p>
              </div>

              <div className="arch-grid">
                <div className="arch-card">
                  <div className="arch-icon">⚡</div>
                  <h3>Sub-300ms Barge-In Abort Loop</h3>
                  <p>Custom AbortController network switch terminates in-flight LLM token generation and PCM streaming the millisecond user speech is recognized by the push-stream.</p>
                </div>
                <div className="arch-card">
                  <div className="arch-icon">🧩</div>
                  <h3>Bilingual Semantic Chunking</h3>
                  <p>Sentence boundary analysis anchored to Hindi dandas (। , ॥) and English terminal stops, preventing synthesis pipeline stutter and maintaining natural cadence.</p>
                </div>
                <div className="arch-card">
                  <div className="arch-icon">🛡️</div>
                  <h3>Air-Gapped Triage Telemetry</h3>
                  <p>Background asynchronous LLM routines aggregate psychological distress signals and generate structured severity markers without exposing sensitive audio logs.</p>
                </div>
              </div>
            </section>

            {/* ABOUT THE FOUNDER / PROVENANCE */}
            <section className="founder-section" id="founder">
              <div className="founder-card">
                <div className="founder-badge">LEAD ARCHITECT</div>
                <div className="founder-content">
                  <h2>Engineering Provenance</h2>
                  <p className="founder-lead">
                    Built by a systems engineer specializing in high-concurrency distributed backends, 
                    crypto-forensic graph systems, and real-time streaming architectures.
                  </p>
                  <div className="provenance-points">
                    <div className="prov-item">
                      <span className="prov-bullet"></span>
                      <div>
                        <strong>Founding Core Engineer (Acquired Platform):</strong> 
                        Architected the multi-chain intelligence and forensic scoring backend for a startup incubated at 
                        IIT Kanpur’s C3iHub, resulting in an acquisition by NSCS and national security bodies.
                      </div>
                    </div>
                    <div className="prov-item">
                      <span className="prov-bullet"></span>
                      <div>
                        <strong>National Law Enforcement Deployment:</strong> 
                        Currently maintaining and scaling the 9-chain forensic search, clustering, and fund-flow tracking engine 
                        utilized daily by Indian Law Enforcement Agencies (LEAs) nationwide.
                      </div>
                    </div>
                    <div className="prov-item">
                      <span className="prov-bullet"></span>
                      <div>
                        <strong>Academic Research in Dialogue Systems:</strong> 
                        Primary researcher behind the peer-reviewed full-duplex conversational AI paper published and presented at 
                        <strong> SIGDIAL (ACL) 2026</strong>.
                      </div>
                    </div>
                  </div>
                  <div className="founder-links">
                    <a 
                      href="https://aclanthology.org/2026.sigdial-1.18/" 
                      target="_blank" 
                      rel="noreferrer" 
                      className="paper-btn"
                    >
                      Read SIGDIAL 2026 Paper ↗
                    </a>
                    <a 
                      href="https://www.linkedin.com/in/yash-raj-singh-a46b3b19/" 
                      target="_blank" 
                      rel="noreferrer" 
                      className="linkedin-btn"
                    >
                      LinkedIn Profile ↗
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* FOOTER */}
            <footer className="landing-footer">
              <div className="footer-content">
                <p>© 2026 Crossoracle.ai — Real-Time Conversational Voice Infrastructure.</p>
                <div className="footer-links">
                  <a href="https://aclanthology.org/2026.sigdial-1.18/" target="_blank" rel="noreferrer">
                    SIGDIAL Paper
                  </a>
                  <a href="https://www.linkedin.com/in/yash-raj-singh-a46b3b19/" target="_blank" rel="noreferrer">
                    LinkedIn
                  </a>
                </div>
              </div>
            </footer>
          </div>
        )}

        {/* ── 2. LOGIN OVERLAY ── */}
        {appMode && !user && (
          <div className="login-overlay">
            <div className="login-content">
              <button className="back-btn" onClick={() => setAppMode(null)}>← BACK</button>
              <h1 className="brand-logo" style={{ color: currentConfig.theme, marginBottom: '20px' }}>{currentConfig.title}</h1>
              
              <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                <GoogleLogin onSuccess={handleGoogleSuccess} onError={() => console.log("Login Failed")} theme="filled_black" shape="pill" size="large" width="100%" />
                <div style={{ color: "#64748b", fontSize: "12px", display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", marginTop: "10px" }}><span style={{ height: "1px", background: "rgba(255,255,255,0.1)", flex: 1 }}></span>PORTAL LOGIN<span style={{ height: "1px", background: "rgba(255,255,255,0.1)", flex: 1 }}></span></div>
                <form onSubmit={handleCustomLogin} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  {authError && <div style={{ color: "#ff4d4d", fontSize: "13px", textAlign: "center" }}>{authError}</div>}
                  <input type="text" placeholder="Username" value={authEmail} onChange={(e) => setAuthEmail(e.target.value)} required style={{ padding: "14px", borderRadius: "8px", border: "1px solid rgba(255,255,255,0.2)", background: "rgba(0,0,0,0.5)", color: "white", outline: "none" }} />
                  <input type="password" placeholder="Password" value={authPassword} onChange={(e) => setAuthPassword(e.target.value)} required style={{ padding: "14px", borderRadius: "8px", border: "1px solid rgba(255,255,255,0.2)", background: "rgba(0,0,0,0.5)", color: "white", outline: "none" }} />
                  <button type="submit" style={{ padding: "14px", borderRadius: "8px", border: "none", background: currentConfig.theme, color: "black", cursor: "pointer", fontWeight: "700", marginTop: "10px", letterSpacing: "1px" }}>ACCESS PLATFORM</button>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* ── 3. NAME CONFIRMATION ── */}
        {user && showNameModal && (
          <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.85)", zIndex: 9999, display: "flex", justifyContent: "center", alignItems: "center", backdropFilter: "blur(15px)" }}>
            <div style={{ background: "rgba(15,23,42,0.8)", padding: "50px", borderRadius: "24px", border: `1px solid ${currentConfig.theme}55`, textAlign: "center", maxWidth: "450px", width: "90%", boxShadow: `0 0 50px ${currentConfig.theme}22` }}>
              <h2 style={{ color: "white", marginBottom: "15px", fontSize: "28px", letterSpacing: "2px" }}>Identity Confirmed.</h2>
              <form onSubmit={handleNameSubmit}>
                <input type="text" value={customName} onChange={(e) => { setCustomName(e.target.value); if (nameError) setNameError(""); }} placeholder="How should we address you?" style={{ width: "100%", padding: "18px", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.2)", background: "rgba(0,0,0,0.5)", color: "white", fontSize: "18px", marginBottom: "10px", textAlign: "center", outline: "none" }} required />
                <button type="submit" style={{ width: "100%", padding: "18px", borderRadius: "12px", border: `1px solid ${currentConfig.theme}`, background: "transparent", color: currentConfig.theme, fontWeight: "700", cursor: "pointer", fontSize: "14px", textTransform: "uppercase", letterSpacing: "4px" }}>Enter Workspace</button>
              </form>
            </div>
          </div>
        )}

        {/* ── FORGE ORACLE MODAL ── */}
        {showForgeModal && (
          <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.92)", zIndex: 9998, display: "flex", justifyContent: "center", alignItems: "center", backdropFilter: "blur(20px)", padding: "20px" }} onClick={(e) => { if (e.target === e.currentTarget) setShowForgeModal(false); }}>
            <div style={{ background: "rgba(8,12,26,0.95)", borderRadius: "28px", border: "1px solid rgba(255,255,255,0.08)", width: "100%", maxWidth: "640px", maxHeight: "90vh", overflowY: "auto", padding: "0", boxShadow: "0 0 80px rgba(0,0,0,0.8)" }}>
              <div style={{ padding: "36px 40px 0" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div>
                    <h2 style={{ color: "white", margin: 0, fontSize: "26px", letterSpacing: "3px", fontWeight: "700" }}>FORGE YOUR ORACLE</h2>
                    <p style={{ color: "#64748b", margin: "8px 0 0", fontSize: "14px", letterSpacing: "1px" }}>Describe who you want to talk to. Be specific.</p>
                  </div>
                  <button onClick={() => { setShowForgeModal(false); setForgeName(""); }} style={{ background: "none", border: "none", color: "#64748b", fontSize: "22px", cursor: "pointer", padding: "4px 8px", lineHeight: 1 }}>✕</button>
                </div>
              </div>
              <div style={{ padding: "28px 40px 0" }}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {PERSONA_TEMPLATES.map((t) => (
                    <button key={t.label} onClick={() => setForgeDesc(t.text)} style={{ background: forgeDesc === t.text ? "rgba(255,255,255,0.1)" : "rgba(255,255,255,0.03)", border: `1px solid ${forgeDesc === t.text ? "rgba(255,255,255,0.25)" : "rgba(255,255,255,0.07)"}`, borderRadius: "50px", padding: "7px 14px", cursor: "pointer", color: forgeDesc === t.text ? "white" : "#94a3b8", fontSize: "13px", display: "flex", alignItems: "center", gap: "6px" }}>
                      <span>{t.emoji}</span><span>{t.label}</span>
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ padding: "20px 40px 0" }}>
                <input type="text" value={forgeName} onChange={(e) => setForgeName(e.target.value.slice(0, 30))} placeholder="Give them a name..." style={{ width: "100%", background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "12px", color: "white", fontSize: "15px", padding: "14px 18px", outline: "none", boxSizing: "border-box" }} />
              </div>
              <div style={{ padding: "20px 40px 0" }}>
                <textarea value={forgeDesc} onChange={(e) => setForgeDesc(e.target.value.slice(0, MAX_DESC_LENGTH))} placeholder="Describe personality in detail..." style={{ width: "100%", minHeight: "180px", background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "16px", color: "white", fontSize: "15px", lineHeight: "1.7", padding: "20px", resize: "vertical", outline: "none", boxSizing: "border-box" }} />
              </div>
              <div style={{ padding: "24px 40px 36px", display: "flex", gap: "12px" }}>
                <button onClick={() => { setShowForgeModal(false); setForgeName(""); }} style={{ flex: 1, padding: "16px", borderRadius: "14px", border: "1px solid rgba(255,255,255,0.08)", background: "transparent", color: "#64748b", fontSize: "13px", cursor: "pointer" }}>CANCEL</button>
                <button onClick={launchCustomPersonaCall} disabled={forgeDesc.trim().length < 15 || !isConnected} style={{ flex: 2, padding: "16px", borderRadius: "14px", cursor: "pointer", border: "1px solid rgba(255,255,255,0.15)", background: "rgba(255,255,255,0.08)", color: "white", fontSize: "13px", fontWeight: "700" }}>SUMMON ORACLE</button>
              </div>
            </div>
          </div>
        )}

        {/* ── 4. MAIN APP DASHBOARD ── */}
        {user && !showNameModal && (
          <>
            <div className={`drawer-overlay ${isDrawerOpen ? "show" : ""}`} onClick={() => setIsDrawerOpen(false)}></div>
            <aside className={`side-drawer ${isDrawerOpen ? "open" : ""}`}>
              <div className="drawer-header"><span className="drawer-title">CATEGORIES</span><button className="close-drawer-btn" onClick={() => setIsDrawerOpen(false)}>✕</button></div>
              <div className="drawer-categories">{currentConfig.tabs.map((cat) => (<button key={cat} className={`drawer-btn ${activeTab === cat ? "active" : ""}`} onClick={() => { setActiveTab(cat); setIsDrawerOpen(false); }}>{cat}</button>))}</div>
            </aside>

            <div className={`grid-view ${inCall ? "hidden" : ""}`}>
              <div className="container">
                <header className="brand-header">
                  <div className="header-left"><button className="menu-toggle-btn" onClick={() => setIsDrawerOpen(true)}>
                    <svg width="30" height="22" viewBox="0 0 30 22" fill="none"><rect y="0" width="30" height="2.5" rx="1.25" fill="currentColor" /><rect y="9.5" width="20" height="2.5" rx="1.25" fill="currentColor" className="mid-bar" /><rect y="19" width="30" height="2.5" rx="1.25" fill="currentColor" /></svg>
                  </button><h1 className="brand-logo" onClick={handleLogoClick}>{currentConfig.title}</h1></div>
                  
                  <div className="header-action-center" style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                    {appMode === 'entertainment' && (
                      <button className="forge-pill-btn" onClick={() => isConnected && setShowForgeModal(true)} style={{ cursor: isConnected ? "pointer" : "not-allowed" }}>
                        <span className="sparkle">✦</span> CREATE YOUR OWN ORACLE
                      </button>
                    )}
                  </div>
                  
                  <div className="header-right" style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                    {user.role === 'counsellor' && appMode === 'safe_space' && (
                      <div onClick={() => { setShowProfile(true); fetchAllSessions(); }} style={{ cursor: "pointer", color: "white", fontSize: "14px", fontWeight: "600", display: "flex", alignItems: "center", gap: "12px", background: "rgba(255,255,255,0.05)", padding: "8px 20px", borderRadius: "50px", border: "1px solid rgba(255,255,255,0.1)" }}>
                        <span style={{ letterSpacing: "1px", fontSize: "16px", textTransform: "capitalize" }}>Admin Dashboard</span>
                      </div>
                    )}
                    <button className="logout-btn" onClick={handleLogout}>SWITCH PLATFORM</button>
                  </div>
                </header>

                {appMode === "ambient" && (activeTab === "Agentic Brain" || activeTab === "All") && (
                  <div className="ambient-upload-panel">
                    <h3 className="ambient-upload-title">Knowledge Document (KD) Ingestion</h3>
                    <p className="ambient-upload-copy">Upload a .pdf, .txt, or .md document to inject context into the Agentic Brain.</p>
                    <input type="file" accept=".pdf,.txt,.md,.json,.csv" className="ambient-upload-input" onChange={handleFileUpload} />
                    {uploadStatus && <div className="ambient-upload-status">{uploadStatus}</div>}
                  </div>
                )}
                
                <div className="expert-grid">
                  {filteredPersonas.map((item) => (
                    <div key={item.id} className={`expert-card ${persona === item.id ? "active" : ""}`} style={{ borderColor: persona === item.id ? currentConfig.theme : "rgba(255,255,255,0.05)" }}>
                      <div className="avatar-section"><div className="avatar-wrapper"><img src={item.image} alt={item.name} /></div></div>
                      <div className="card-content">
                        <div className="meta"><h3>{item.name}</h3><p className="role" style={{ color: currentConfig.theme }}>{item.role}</p><p className="tagline">{item.tagline}</p></div>
                        <button className="card-btn" onClick={() => toggleCall(item.id)} disabled={!isConnected}>{item.buttonText}</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* ── ADMIN DASHBOARD (SAFE SPACE ONLY) ── */}
            {showProfile && user.role === 'counsellor' && appMode === 'safe_space' && (
              <div className="profile-overlay" style={{ position: "fixed", inset: 0, background: "rgba(2, 6, 23, 0.95)", zIndex: 10000, overflowY: "auto", padding: "40px 20px", backdropFilter: "blur(20px)" }}>
                <div className="profile-container" style={{ maxWidth: "1000px", margin: "0 auto", position: "relative" }}>
                  <button className="close-profile-btn" onClick={() => setShowProfile(false)} style={{ position: "absolute", top: "0", right: "0", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", color: "white", width: "40px", height: "40px", borderRadius: "50%", cursor: "pointer", fontSize: "20px" }}>✕</button>
                  <h2 style={{ fontSize: "36px", fontWeight: "300", letterSpacing: "6px", color: "white", marginBottom: "40px", textAlign: "center" }}>
                    CMHW ADMIN <span style={{ color: currentConfig.theme }}>DASHBOARD</span>
                  </h2>

                  <div className="profile-card" style={{ background: "rgba(30, 41, 59, 0.45)", borderRadius: "24px", border: "1px solid rgba(255,255,255,0.08)", padding: "30px", marginTop: "40px" }}>
                    <div style={{ overflowX: "auto" }}>
                      <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
                        <thead>
                          <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                            <th style={{ padding: "12px", color: "#94a3b8", fontSize: "12px", fontWeight: "600" }}>DATE</th>
                            <th style={{ padding: "12px", color: "#94a3b8", fontSize: "12px", fontWeight: "600" }}>STUDENT</th>
                            <th style={{ padding: "12px", color: "#94a3b8", fontSize: "12px", fontWeight: "600" }}>PERSONA / DOMAIN</th>
                            <th style={{ padding: "12px", color: "#94a3b8", fontSize: "12px", fontWeight: "600" }}>DURATION</th>
                            <th style={{ padding: "12px", color: "#94a3b8", fontSize: "12px", fontWeight: "600" }}>SEVERITY</th>
                            <th style={{ padding: "12px", color: "#94a3b8", fontSize: "12px", fontWeight: "600" }}>CONTEXT</th>
                            <th style={{ padding: "12px", color: "#94a3b8", fontSize: "12px", fontWeight: "600" }}>ACTION</th>
                          </tr>
                        </thead>
                        <tbody>
                          {allSessions.length === 0 ? (
                            <tr>
                              <td colSpan={7} style={{ padding: "20px", textAlign: "center", color: "#64748b" }}>No sessions found.</td>
                            </tr>
                          ) : (
                            allSessions.map((session, idx) => (
                              <tr key={idx} style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                                <td style={{ padding: "12px", color: "#e2e8f0", fontSize: "13px" }}>{new Date(session.createdAt || session.startTime).toLocaleString()}</td>
                                <td style={{ padding: "12px", color: "#e2e8f0", fontSize: "13px" }}>{session.email}</td>
                                <td style={{ padding: "12px", color: "#e2e8f0", fontSize: "13px" }}>{session.domain || PERSONAS[session.persona]?.name || session.persona}</td>
                                <td style={{ padding: "12px", color: "#e2e8f0", fontSize: "13px" }}>{session.durationMinutes ? `${session.durationMinutes} min` : "< 1 min"}</td>
                                <td style={{ padding: "12px" }}>
                                  <span style={{ padding: "6px 12px", borderRadius: "50px", fontSize: "11px", fontWeight: "700", background: (session.severity || session.threatLevel) === "High" ? "rgba(239, 68, 68, 0.2)" : (session.severity || session.threatLevel) === "Medium" ? "rgba(245, 158, 11, 0.2)" : "rgba(16, 185, 129, 0.2)", color: (session.severity || session.threatLevel) === "High" ? "#ef4444" : (session.severity || session.threatLevel) === "Medium" ? "#f59e0b" : "#10b981" }}>
                                    {(session.severity || session.threatLevel || "LOW").toUpperCase()}
                                  </span>
                                </td>
                                <td style={{ padding: "12px", color: "#e2e8f0", fontSize: "13px", fontStyle: "italic" }}>"{session.context || session.summary}"</td>
                                <td style={{ padding: "12px" }}>
                                  <a href={`mailto:${session.email}?subject=Follow-up Session: ${session.sessionId}`} style={{ display: "inline-block", background: "rgba(59, 130, 246, 0.1)", border: "1px solid #3b82f6", color: "#3b82f6", padding: "6px 12px", borderRadius: "50px", fontSize: "11px", fontWeight: "700", textDecoration: "none", cursor: "pointer", whiteSpace: "nowrap" }}>
                                    CONTACT STUDENT
                                  </a>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* ── CALL VIEW OVERLAY ── */}
            <div className={`call-view ${inCall ? "active" : ""}`}>
              <div className="call-topbar">
                <button className="end-call-btn" onClick={stopCall}><span className="end-icon">✕</span> END CALL</button>
              </div>
              <div className="call-content">
                <div className="avatar-large">
                  <div className={`avatar-frame ${isAiThinking ? "state-thinking" : ""} ${aiIsSpeaking ? "state-speaking" : ""}`} style={{ borderColor: (isAiThinking || aiIsSpeaking) ? currentConfig.theme : "rgba(255,255,255,0.1)" }}>
                    <img src={currentPersona?.image} alt={currentPersona?.name} />
                  </div>
                </div>
                <div className="persona-info">
                  <div style={{ color: currentConfig.theme, fontSize: "14px", fontWeight: "700", letterSpacing: "2px", marginBottom: "8px" }}>{formatDuration(sessionDuration)}</div>
                  <h2 className="persona-name">{customPersonaInfo?.name || currentPersona?.name}</h2>
                  <p className="persona-role" style={{ color: currentConfig.theme }}>{customPersonaInfo ? "Your Custom Oracle" : currentPersona?.role}</p>
                  {(aiIsSpeaking || isAiThinking) && (
                    <button className="interrupt-btn-inline" onClick={interruptAI} title="Interrupt (Spacebar)"><span className="interrupt-icon">⏹</span> INTERRUPT</button>
                  )}
                </div>
              </div>
            </div>

            {/* ── HUD TERMINAL OVERLAY ── */}
            {showTelemetryHUD && <TelemetryTerminal logs={telemetryLogs} onClose={() => setShowTelemetryHUD(false)} />}
          </>
        )}
      </div>
    </GoogleOAuthProvider>
  );
}